import { useAuthContext } from "providers/Auth";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { useMedia } from "shared/providers";
import { Property } from "types/landlord/address";
import { Plus } from "untitledui-js-base";

interface LayoutFooterProps {
  onOpenInviteModal: () => void;
  property: Property;
}

export const LayoutFooter = memo(
  ({ onOpenInviteModal, property }: LayoutFooterProps) => {
    const { isMobile } = useMedia();
    const { type } = useAuthContext();
    const navigate = useNavigate();
    const dictionary = useUnitsPropertiesDictionary();

    if (!isMobile) return null;

    return (
      <div className="flex items-center gap-2">
        <Button
          onClick={onOpenInviteModal}
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          size={ButtonSize.SM}
          Icon={Plus}
        >
          Invite applicants
        </Button>

        {type.isPMS || type.isPropertyManager ? null : (
          <Button
            size={ButtonSize.SM}
            variant={ButtonVariant.PRIMARY}
            className="w-full"
            onClick={() =>
              navigate(`/properties/${property.id}/units/add`, {
                state: {
                  property
                }
              })
            }
            Icon={Plus}
          >
            Add {dictionary.Units}
          </Button>
        )}
      </div>
    );
  }
);

LayoutFooter.displayName = "LayoutFooter";
